<template>
  <div>
    <HeaderCont />
    <TitleCont name1="reference" name2="api" />
    <section className="cont__refer">
      <div className="container">
        <div className="refer__inner">
          <h2>CSS</h2>
          <ul className="refer__list">
            <li v-for="refer in refers" :key="refer.name">
              <a href="/">
                <!-- <span>{{ refer.num }}</span> -->
                <span>{{ refer.name }}</span>
                <span>{{ refer.desc }}</span>
                <span>{{ refer.descStar }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <ContactCont />
    <FooterCont />
  </div>
</template>

<script>
import HeaderCont from "@/components/HeaderCont.vue";
import TitleCont from "@/components/TitleCont.vue";
import FooterCont from "@/components/FooterCont.vue";
import ContactCont from "@/components/ContactCont.vue";
import { ref } from "vue";

export default {
  components: {
    HeaderCont,
    TitleCont,
    FooterCont,
    ContactCont,
  },

  setup() {
    const refers = ref([]);

    const references = () => {
      fetch(
        "https://raw.githubusercontent.com/KwonHyehyeon/react_api/main/util/reference.json"
      )
        .then((response) => response.json())
        // .then((result) => console.log(result.cssRefer))
        .then((result) => (refers.value = result.cssRefer))
        .catch((error) => console.log("error", error));
    };
    references();

    return {
      refers,
      references,
    };
  },
};
</script>

<style lang="scss">
.refer__inner {
  padding-bottom: 200px;

  h2 {
    font-size: 30px;
    color: var(--black);
  }
}

.refer__list {
  border: 1px solid var(--bg-dark-border);
  li {
    border-bottom: 1px solid var(--bg-dark-border);

    a {
      display: flex;
      align-items: center;
      width: 100%;
      color: var(--black);
      font-family: var(--font-kor1);
      // padding: 10px;
      &:hover {
        background-color: rgb(255, 162, 201);
        color: #000;
      }

      span {
        display: inline-block;
        padding: 15px 20px;
      }
      .num {
        flex: 1 1 5%;
        text-align: center;
        border-right: 1px solid var(--bg-dark-border);
      }
      .title {
        flex: 1 1 26%;
        text-align: center;
      }
      .desc {
        flex: 1 1 82%;
        border-left: 1px solid var(--bg-dark-border);
        font-size: 16px;
      }
      .descBasic {
        flex: 1 1 23%;
        text-align: center;
        border-left: 1px solid var(--bg-dark-border);
        font-size: 14px;
      }
      .descApple {
        flex: 1 1 12%;
        text-align: center;
        border-left: 1px solid var(--bg-dark-border);
        font-size: 12px;
      }
      .descVer {
        flex: 1 1 3%;
        text-align: center;
        border-left: 1px solid var(--bg-dark-border);
        font-size: 12px;
      }
      .descStar {
        flex: 1 1 5%;
        text-align: center;
        border-left: 1px solid var(--bg-dark-border);
        font-size: 12px;
      }
    }
  }
}
</style>
